// extracted by mini-css-extract-plugin
export var actions = "_dr-d";
export var benefitCard = "_dr-a";
export var benefitIcon = "_dr-b";
export var benefitLabel = "_dr-c";
export var benefits = "_dr-9";
export var bodyText = "_dr-8";
export var closeButton = "_dr-2";
export var content = "_dr-3";
export var eyebrow = "_dr-4";
export var heading = "_dr-5";
export var image = "_dr-f";
export var imagePanel = "_dr-e";
export var modal = "_dr-0";
export var shell = "_dr-1";
export var title = "_dr-6";
export var titleOffer = "_dr-7";